import type { Crumbs } from '~/types/commons'

export const useBreadcrumbs = () => {
  const route = useRoute()
  const router = useRouter()

  const { getTranslatedLink } = useGetTranslatedLink()

  const indexCrumb = { name: 'index', path: '/', translatedName: getTranslatedLink('index') }

  const isMatchPatternPath = (pathA: string, pathB: string) => {
    const partsA = pathA.split('/')
    const partsB = pathB.split('/')

    if (partsA.length !== partsB.length) {
      return false
    }

    return partsA.every((part: string, i: number) => {
      return part === partsB[i] || part.startsWith(':')
    })
  }

  const getBreadcrumbs = (currRoute: string): Crumbs[] => {
    if (currRoute === '') {
      return [indexCrumb]
    }
    if (currRoute.slice(-1) === '/') {
      return getBreadcrumbs(currRoute.slice(0, currRoute.lastIndexOf('/')))
    }
    const paths = getBreadcrumbs(currRoute.slice(0, currRoute.lastIndexOf('/')))
    const founds = router.getRoutes().filter(routeToTest => isMatchPatternPath(routeToTest.path, currRoute))
    const matchRoute = founds.length > 1 ? founds.find(route => route.path === currRoute) : founds[0]

    const name = matchRoute?.name?.toString() || currRoute
    const translatedName = name ? getTranslatedLink(name) : null

    return [
      ...paths,
      {
        path: currRoute,
        name,
        translatedName,
      },
    ]
  }

  return {
    crumbs: computed(() => getBreadcrumbs(route.path)),
  }
}
